module.exports = __webpack_public_path__ + "static/media/icon-status-at-shipper.ddabc339.svg";